<script lang="ts" setup>
// #region Composables
import { EContext } from '~/features-shared/config-manager/interfaces/contexts'
import {
  currentContext,
  search,
  togglePanel,
  togglePanelPin,
} from '~/features-shared/left-panel/composables/left-panel-manager'

import { useFeatureManager } from '~/features-generic/config-manager/composables/feature-manager'
import LeftPanelHeader from '~/features-generic/left-panel/components/left-panel-header.vue'
import { useTranslations } from '~/features-generic/translations/composables/translations'

// #end region Composables

// #region Props
const props = defineProps<{
  /* Constraints on whether an icon should be displayed or not in the panel-header according to context */
  showIconsConstraints?: { [context: string]: boolean }
}>()
// #endregion Props

// #region Composables Instantiation
const isMobileBreakpoint = useFeatureManager('app.config.mobile_breakpoint')
const { $i18n } = useTranslations('left-panel-header')
// #endregion Composables Instantiation
</script>

<template>
  <div class="left-panel-container relative gap-2.5 pt-[10px] sm:pt-[38px]">
    <div
      v-if="!isMobileBreakpoint"
      class="absolute right-0 top-0"
    >
      <vu-icon-btn
        v-tooltip="$i18n('close')"
        icon="close text-lg"
        @click="togglePanel(false); togglePanelPin(false)"
      />
    </div>
    <slot name="header">
      <LeftPanelHeader
        v-if="!isMobileBreakpoint"
        :context="currentContext"
        :enable-search="currentContext !== EContext.ME"
        :show-icons-constraints="props.showIconsConstraints"
        @search="search"
      />
    </slot>
    <slot name="body" />
  </div>
</template>

<style lang="scss" scoped>
// eslint-disable-next-line vue-scoped-css/require-selector-used-inside
.left-panel-container {
  display: flex;
  flex-direction: column;
  overflow: hidden;
  height: 100%;
  background-color: white;
  -webkit-user-select: none; /* Safari */
  user-select: none; /* Standard syntax */
}
</style>
